<template>
  <div>
    <form class="grid-form">
      <fieldset>
        <legend>
          {{ title }}
          <span class="text-normal">
            &nbsp;&nbsp; ( {{ "IV - " + invoice.invoice_number }} )
          </span>
          <span class="float-right">
            &nbsp;&nbsp;
            {{
              this.$route.params.type == "expenditure" ? "Expense" : "Income"
            }}
          </span>
        </legend>
        <div data-row-span="8">
          <!-- <div data-field-span="3">
                        <label>Invoice No.</label>
                        <input type="text" class="disabled" readonly :value="">
                    </div> -->
          <div data-field-span="2">
            <label>Express Ref. No.</label>
            <input type="text" v-model="invoice.express_reference_number" />
          </div>
          <div data-field-span="2">
            <label>Ref. Invoice No.</label>
            <input type="text" v-model="invoice.reference_invoice_number" />
          </div>
          <div data-field-span="2">
            <label>Invoice Date</label>
            <datetime
              placeholder="PICK DATE"
              v-model="invoice.invoice_date"
              value-zone="Asia/Bangkok"
              :auto="true"
              input-id="invoice-date"
              input-class="date-picker"
            >
            </datetime>
          </div>
          <div data-field-span="2">
            <label>Due Date</label>
            <datetime
              placeholder="PICK DATE"
              v-model="invoice.due_date"
              value-zone="Asia/Bangkok"
              :auto="true"
              input-id="due-date"
              input-class="date-picker"
            >
            </datetime>
          </div>
        </div>
        <div data-row-span="4">
          <div data-field-span="1">
            <contact-select :contact="invoice.contact_name" @input="pickUser" />
          </div>

          <!-- <div data-field-span="1">
                        <label>RECIPIENT / SENDER CODE</label>
                        <input type="text" v-model="invoice.contact_code">
                    </div> -->

          <div data-field-span="1">
            <label>Phone</label>
            <input type="text" v-model="invoice.contact_phone" />
          </div>

          <div data-field-span="1">
            <label>Email</label>
            <input type="text" v-model="invoice.contact_email" />
          </div>

          <div data-field-span="1">
            <label>Tax ID</label>
            <input type="text" v-model="invoice.contact_tax_id" />
          </div>
        </div>
        <div data-row-span="1">
          <div data-field-span="1">
            <label>Address</label>
            <textarea
              rows="2"
              v-model="invoice.contact_address"
              placeholder="Address"
            ></textarea>
          </div>
        </div>
        <div data-row-span="5">
          <div data-field-span="1">
            <account-select
              :account="invoice.account.account_name"
              @input="pickAccount"
            />
          </div>
          <div data-field-span="1">
            <label>Payment Ref. No.</label>
            <input type="text" v-model="invoice.transaction_reference_number" />
          </div>
          <div data-field-span="1">
            <label>Prepaid by</label>
            <input type="text" v-model="invoice.prepaid_by" />
          </div>
          <div data-field-span="1">
            <label>Payment Date Time</label>
            <datetime
              placeholder="PICK DATE"
              v-model="invoice.transaction_date_time"
              value-zone="Asia/Bangkok"
              :auto="true"
              input-id="transaction_date_time"
              type="datetime"
              input-class="date-picker"
            >
            </datetime>
          </div>
          <div data-field-span="1">
            <label>Cost Belong To</label>
            <vue-monthly-picker
              dateFormat="MMM, YYYY"
              v-model="invoice.cost_belong_to"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";
import ContactSelect from "./ContactSelect";
import AccountSelect from "./AccountSelect";

export default {
  components: {
    ContactSelect,
    VueMonthlyPicker,
    AccountSelect,
  },
  props: {
    invoice: {
      default: {},
      type: Object,
    },
    title: String,
  },
  methods: {
    pickAccount(account) {
      this.invoice.account = account;
    },
    pickUser(user) {
      if (user.name) {
        this.invoice.contact_name = user.name;
        this.invoice.contact_code = user.code;
        this.invoice.contact_email = user.email;
        this.invoice.contact_phone = user.phone;
        this.invoice.contact_tax_id = user.tax_id;
        this.invoice.contact_address = user.address;
      } else {
        this.invoice.contact_name = null;
        this.invoice.contact_code = "";
        this.invoice.contact_email = null;
        this.invoice.contact_phone = null;
        this.invoice.contact_tax_id = null;
        this.invoice.contact_address = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid-form fieldset legend {
  margin-bottom: 0px !important;
}
.grid-form input {
  height: 40px !important;
  border: 1px solid #e8e8e8 !important;
  border-radius: 5px !important;
  padding: 0px 13px !important;
  font-size: 14px !important;
  font-family: monospace;
}
.grid-form textarea {
  border: 1px solid #e8e8e8 !important;
  border-radius: 5px !important;
  padding: 13px !important;
  font-size: 14px !important;
}
.input-group-text {
  border-left: 0px !important;
  background: white !important;
  color: black !important;
}
.br-0 {
  border-right: 0px !important;
}
.br-0:focus {
  border: 1px solid #ebedf2 !important;
  border-right: 0px !important;
}
select.form-control {
  width: 100%;
  text-transform: uppercase;
  font-weight: bold;
  border: 1px solid #e9ecef;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #ffffff;
}
.form-control {
  padding: 5px !important;
}
.form-control.error {
  border: 1px solid red !important;
}
.b-0 {
  border: none !important;
}
.disabled {
  background: gainsboro !important;
  cursor: no-drop;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 250px;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
  z-index: 200;
}
.text-normal {
  font-weight: 500;
}
</style>
